import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArAE: CultureInfo = {
  name: 'ar-AE',
  displayName: 'Arabic (United Arab Emirates)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-AE',
  parent: CultureInfoAr
};
